import { baseUrlsWS } from "./base-url";
import { environment } from "./enum";

let BASE_URL_USER_SERVICE;
let BASE_URL_DOCBUILDER_SERVICE;
let BASE_URL_DOCPARSER_SERVICE;
let BASE_URL_EVENT_SERVICE;
let BASE_URL_AUTH_SERVICE;
let BASE_URL_META_CONTENT_SERVICE;
let VISITOR_SERVICE_URL;
let BASE_URL_PAYMENT_SERVICE;
let BASE_URL_ORDER_SERVICE;
let BASE_URL_PAYMENT_ORCHESTRATION_SERVICE;
let BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI;
let BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI;
let BASE_URL_SSO_PARTNER_LOGIN_WORKSIMPLI;
let BASE_URL_SSO_DASHBOARD;
let BASE_URL_SIGNSIMPI;
let BASE_URL_PDFSIMPI;
let BASE_DASHBOARD_ORCHESTRATION;
let BASE_URL_TRUSTPILOT;
let BASE_URL_ABTEST;
let BASE_URL_LEGALSIMPLI;
let BASE_URL_DOCOPERATION_SERVICE;
let BASE_URL_JOBMANAGER_SERVICE;
let BASE_URL_SIGNSIMPLI_ORCH_SERVICE;
let BASE_URL_RESUMEBUILD;
let BASE_URL_DOC_EDITOR_SERVICE;
let BASE_URL_DOCPROFILE_API;
let BASE_URL_PDFSIMPLI_ENDPOINT;
let BASE_URL_SIGNSIMPLI_ENDPOINT;
let BASE_URL_WORKSIMPLI;

const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;
let baseUrls;
let baseUrlsVistorJs = "https://static-bw-qa.worksimpli.io/content/js/visitor.js";

baseUrls = baseUrlsWS;
if (currentEnv === "STAGING" || currentEnv === "PRODUCTION") {
  baseUrlsVistorJs = "https://static-bw.worksimpli.io/content/js/visitor.js";
}

const baseUrl = {
  userService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.USER_SERVICE,
    QA: baseUrls.QA.USER_SERVICE,
    STAGING: baseUrls.STAGING.USER_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.USER_SERVICE,
  },
  docBuilderService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.DOCBUILDER_SERVICE,
    QA: baseUrls.QA.DOCBUILDER_SERVICE,
    STAGING: baseUrls.STAGING.DOCBUILDER_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.DOCBUILDER_SERVICE,
  },
  docParserService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.DOCPARSER_SERVICE,
    QA: baseUrls.QA.DOCPARSER_SERVICE,
    STAGING: baseUrls.STAGING.DOCPARSER_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.DOCPARSER_SERVICE,
  },
  eventService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.EVENT_SERVICE,
    QA: baseUrls.QA.EVENT_SERVICE,
    STAGING: baseUrls.STAGING.EVENT_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.EVENT_SERVICE,
  },
  authService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.AUTH_SERVICE,
    QA: baseUrls.QA.AUTH_SERVICE,
    STAGING: baseUrls.STAGING.AUTH_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.AUTH_SERVICE,
  },
  metaContentService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.META_CONTENT_SERVICE,
    QA: baseUrls.QA.META_CONTENT_SERVICE,
    STAGING: baseUrls.STAGING.META_CONTENT_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.META_CONTENT_SERVICE,
  },
  paymentService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.PAYMENT_SERVICE,
    QA: baseUrls.QA.PAYMENT_SERVICE,
    STAGING: baseUrls.STAGING.PAYMENT_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.PAYMENT_SERVICE,
  },
  orderService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.ORDER_SERVICE,
    QA: baseUrls.QA.ORDER_SERVICE,
    STAGING: baseUrls.STAGING.ORDER_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.ORDER_SERVICE,
  },
  orchestrationService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.PAYMENT_ORCHESTRATION_SERVICE,
    QA: baseUrls.QA.PAYMENT_ORCHESTRATION_SERVICE,
    STAGING: baseUrls.STAGING.PAYMENT_ORCHESTRATION_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.PAYMENT_ORCHESTRATION_SERVICE,
  },
  ssoPdfSimpli: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.SINGLE_SIGN_ON_PDFSIMPLI,
    QA: baseUrls.QA.SINGLE_SIGN_ON_PDFSIMPLI,
    STAGING: baseUrls.STAGING.SINGLE_SIGN_ON_PDFSIMPLI,
    PRODUCTION: baseUrls.PRODUCTION.SINGLE_SIGN_ON_PDFSIMPLI,
  },
  ssoSignSimpli: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.SINGLE_SIGN_ON_SIGNSIMPLI,
    QA: baseUrls.QA.SINGLE_SIGN_ON_SIGNSIMPLI,
    STAGING: baseUrls.STAGING.SINGLE_SIGN_ON_SIGNSIMPLI,
    PRODUCTION: baseUrls.PRODUCTION.SINGLE_SIGN_ON_SIGNSIMPLI,
  },
  ssoWorkSimpli: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.SINGLE_SIGN_ON_WORKSIMPLI,
    QA: baseUrls.QA.SINGLE_SIGN_ON_WORKSIMPLI,
    STAGING: baseUrls.STAGING.SINGLE_SIGN_ON_WORKSIMPLI,
    PRODUCTION: baseUrls.PRODUCTION.SINGLE_SIGN_ON_WORKSIMPLI,
  },
  ssoDashboard: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.SINGLE_SIGN_ON_DASHBOARD,
    QA: baseUrls.QA.SINGLE_SIGN_ON_DASHBOARD,
    STAGING: baseUrls.STAGING.SINGLE_SIGN_ON_DASHBOARD,
    PRODUCTION: baseUrls.PRODUCTION.SINGLE_SIGN_ON_DASHBOARD,
  },
  pdfSimpli: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.PDFSIMPLI_URL,
    QA: baseUrls.QA.PDFSIMPLI_URL,
    STAGING: baseUrls.STAGING.PDFSIMPLI_URL,
    PRODUCTION: baseUrls.PRODUCTION.PDFSIMPLI_URL,
  },
  resumeBuild: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.RESUMEBUILD_URL,
    QA: baseUrls.QA.RESUMEBUILD_URL,
    STAGING: baseUrls.STAGING.RESUMEBUILD_URL,
    PRODUCTION: baseUrls.PRODUCTION.RESUMEBUILD_URL,
  },
  signSimpli: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.SIGNSIMPLI_URL,
    QA: baseUrls.QA.SIGNSIMPLI_URL,
    STAGING: baseUrls.STAGING.SIGNSIMPLI_URL,
    PRODUCTION: baseUrls.PRODUCTION.SIGNSIMPLI_URL,
  },
  dashboardOrchestrationService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.DASHBOARD_ORCH_SERVICE,
    QA: baseUrls.QA.DASHBOARD_ORCH_SERVICE,
    STAGING: baseUrls.STAGING.DASHBOARD_ORCH_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.DASHBOARD_ORCH_SERVICE,
  },
  TrustPilotService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.TRUSTPILOT_SERVICE,
    QA: baseUrls.QA.TRUSTPILOT_SERVICE,
    STAGING: baseUrls.STAGING.TRUSTPILOT_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.TRUSTPILOT_SERVICE,
  },
  abtestService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.ABTEST_SERVICE,
    QA: baseUrls.QA.ABTEST_SERVICE,
    STAGING: baseUrls.STAGING.ABTEST_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.ABTEST_SERVICE,
  },
  legalSimpli: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.LEGALSIMPLI_URL,
    QA: baseUrls.QA.LEGALSIMPLI_URL,
    STAGING: baseUrls.STAGING.LEGALSIMPLI_URL,
    PRODUCTION: baseUrls.PRODUCTION.LEGALSIMPLI_URL,
  },
  docOperationService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.DOCOPERATION_SERVICE,
    QA: baseUrls.QA.DOCOPERATION_SERVICE,
    STAGING: baseUrls.STAGING.DOCOPERATION_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.DOCOPERATION_SERVICE,
  },
  jobManagerService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.JOBMANGER_SERVICE,
    QA: baseUrls.QA.JOBMANGER_SERVICE,
    STAGING: baseUrls.STAGING.JOBMANGER_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.JOBMANGER_SERVICE,
  },
  signSimpliOrchServcie: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.SIGNSIMPLI_ORCH,
    QA: baseUrls.QA.SIGNSIMPLI_ORCH,
    STAGING: baseUrls.STAGING.SIGNSIMPLI_ORCH,
    PRODUCTION: baseUrls.PRODUCTION.SIGNSIMPLI_ORCH,
  },

  DocEditorService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.DOC_EDITOR_SERVICE,
    QA: baseUrls.QA.DOC_EDITOR_SERVICE,
    STAGING: baseUrls.STAGING.DOC_EDITOR_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.DOC_EDITOR_SERVICE,
  },
  docProfileService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.DOC_PROFILE_SERVICE,
    QA: baseUrls.QA.DOC_PROFILE_SERVICE,
    STAGING: baseUrls.STAGING.DOC_PROFILE_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.DOC_PROFILE_SERVICE,
  },
  pdfsimpliEndPoint: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.PDFSIMPLI_URL,
    QA: baseUrls.QA.PDFSIMPLI_URL,
    STAGING: baseUrls.STAGING.PDFSIMPLI_URL,
    PRODUCTION: baseUrls.PRODUCTION.PDFSIMPLI_URL,
  },
  signsimpliEndPoint: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.SIGNSIMPLI_URL,
    QA: baseUrls.QA.SIGNSIMPLI_URL,
    STAGING: baseUrls.STAGING.SIGNSIMPLI_URL,
    PRODUCTION: baseUrls.PRODUCTION.SIGNSIMPLI_URL,
  },
  worksimpliEndPoint: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.WORKSIMPLI_URL,
    QA: baseUrls.QA.WORKSIMPLI_URL,
    STAGING: baseUrls.STAGING.WORKSIMPLI_URL,
    PRODUCTION: baseUrls.PRODUCTION.WORKSIMPLI_URL,
  },
};
switch (currentEnv) {
  case environment.DEVELOPMENT:
    BASE_URL_USER_SERVICE = baseUrl.userService.DEVELOPMENT;
    BASE_URL_DOCBUILDER_SERVICE = baseUrl.docBuilderService.DEVELOPMENT;
    BASE_URL_DOCPARSER_SERVICE = baseUrl.docParserService.DEVELOPMENT;
    BASE_URL_EVENT_SERVICE = baseUrl.eventService.DEVELOPMENT;
    BASE_URL_AUTH_SERVICE = baseUrl.authService.DEVELOPMENT;
    BASE_URL_META_CONTENT_SERVICE = baseUrl.metaContentService.DEVELOPMENT;
    BASE_URL_PAYMENT_SERVICE = baseUrl.paymentService.DEVELOPMENT;
    BASE_URL_ORDER_SERVICE = baseUrl.orderService.DEVELOPMENT;
    VISITOR_SERVICE_URL = baseUrlsVistorJs;
    BASE_URL_PAYMENT_ORCHESTRATION_SERVICE = baseUrl.orchestrationService.DEVELOPMENT;
    BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI = baseUrl.ssoPdfSimpli.DEVELOPMENT;
    BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI = baseUrl.ssoSignSimpli.DEVELOPMENT;
    BASE_URL_SSO_PARTNER_LOGIN_WORKSIMPLI = baseUrl.ssoWorkSimpli.DEVELOPMENT;
    BASE_URL_SSO_DASHBOARD = baseUrl.ssoDashboard.DEVELOPMENT;
    BASE_URL_SIGNSIMPI = baseUrl.signSimpli.DEVELOPMENT;
    BASE_URL_PDFSIMPI = baseUrl.pdfSimpli.DEVELOPMENT;
    BASE_URL_RESUMEBUILD = baseUrl.resumeBuild.DEVELOPMENT;
    BASE_DASHBOARD_ORCHESTRATION = baseUrl.dashboardOrchestrationService.DEVELOPMENT;
    BASE_URL_TRUSTPILOT = baseUrl.TrustPilotService.DEVELOPMENT;
    BASE_URL_ABTEST = baseUrl.abtestService.DEVELOPMENT;
    BASE_URL_LEGALSIMPLI = baseUrl.legalSimpli.DEVELOPMENT;
    BASE_URL_DOCOPERATION_SERVICE = baseUrl.docOperationService.DEVELOPMENT;
    BASE_URL_JOBMANAGER_SERVICE = baseUrl.jobManagerService.DEVELOPMENT;
    BASE_URL_SIGNSIMPLI_ORCH_SERVICE = baseUrl.signSimpliOrchServcie.DEVELOPMENT;
    BASE_URL_DOC_EDITOR_SERVICE = baseUrl.DocEditorService.DEVELOPMENT;
    BASE_URL_DOCPROFILE_API = baseUrl.docProfileService.DEVELOPMENT;
    BASE_URL_PDFSIMPLI_ENDPOINT = baseUrl.pdfsimpliEndPoint.DEVELOPMENT;
    BASE_URL_SIGNSIMPLI_ENDPOINT = baseUrl.signsimpliEndPoint.DEVELOPMENT;
    BASE_URL_WORKSIMPLI = baseUrl.worksimpliEndPoint.DEVELOPMENT;
    break;
  case environment.QA:
    BASE_URL_USER_SERVICE = baseUrl.userService.QA;
    BASE_URL_DOCBUILDER_SERVICE = baseUrl.docBuilderService.QA;
    BASE_URL_DOCPARSER_SERVICE = baseUrl.docParserService.QA;
    BASE_URL_EVENT_SERVICE = baseUrl.eventService.QA;
    BASE_URL_AUTH_SERVICE = baseUrl.authService.QA;
    BASE_URL_META_CONTENT_SERVICE = baseUrl.metaContentService.QA;
    BASE_URL_PAYMENT_SERVICE = baseUrl.paymentService.QA;
    BASE_URL_ORDER_SERVICE = baseUrl.orderService.QA;
    VISITOR_SERVICE_URL = baseUrlsVistorJs;
    BASE_URL_PAYMENT_ORCHESTRATION_SERVICE = baseUrl.orchestrationService.QA;
    BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI = baseUrl.ssoPdfSimpli.QA;
    BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI = baseUrl.ssoSignSimpli.QA;
    BASE_URL_SSO_PARTNER_LOGIN_WORKSIMPLI = baseUrl.ssoWorkSimpli.QA;
    BASE_URL_SSO_DASHBOARD = baseUrl.ssoDashboard.QA;
    BASE_URL_SIGNSIMPI = baseUrl.signSimpli.QA;
    BASE_URL_PDFSIMPI = baseUrl.pdfSimpli.QA;
    BASE_URL_RESUMEBUILD = baseUrl.resumeBuild.QA;
    BASE_DASHBOARD_ORCHESTRATION = baseUrl.dashboardOrchestrationService.QA;
    BASE_URL_TRUSTPILOT = baseUrl.TrustPilotService.QA;
    BASE_URL_ABTEST = baseUrl.abtestService.QA;
    BASE_URL_LEGALSIMPLI = baseUrl.legalSimpli.QA;
    BASE_URL_DOCOPERATION_SERVICE = baseUrl.docOperationService.QA;
    BASE_URL_JOBMANAGER_SERVICE = baseUrl.jobManagerService.QA;
    BASE_URL_SIGNSIMPLI_ORCH_SERVICE = baseUrl.signSimpliOrchServcie.QA;
    BASE_URL_DOC_EDITOR_SERVICE = baseUrl.DocEditorService.QA;
    BASE_URL_DOCPROFILE_API = baseUrl.docProfileService.QA;
    BASE_URL_PDFSIMPLI_ENDPOINT = baseUrl.pdfsimpliEndPoint.QA;
    BASE_URL_SIGNSIMPLI_ENDPOINT = baseUrl.signsimpliEndPoint.QA;
    BASE_URL_WORKSIMPLI = baseUrl.worksimpliEndPoint.QA;
    break;
  case environment.STAGING:
    BASE_URL_USER_SERVICE = baseUrl.userService.STAGING;
    BASE_URL_DOCBUILDER_SERVICE = baseUrl.docBuilderService.STAGING;
    BASE_URL_DOCPARSER_SERVICE = baseUrl.docParserService.STAGING;
    BASE_URL_EVENT_SERVICE = baseUrl.eventService.STAGING;
    BASE_URL_AUTH_SERVICE = baseUrl.authService.STAGING;
    BASE_URL_META_CONTENT_SERVICE = baseUrl.metaContentService.STAGING;
    BASE_URL_PAYMENT_SERVICE = baseUrl.paymentService.STAGING;
    BASE_URL_ORDER_SERVICE = baseUrl.orderService.STAGING;
    VISITOR_SERVICE_URL = baseUrlsVistorJs;
    BASE_URL_PAYMENT_ORCHESTRATION_SERVICE = baseUrl.orchestrationService.STAGING;
    BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI = baseUrl.ssoPdfSimpli.STAGING;
    BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI = baseUrl.ssoSignSimpli.STAGING;
    BASE_URL_SSO_PARTNER_LOGIN_WORKSIMPLI = baseUrl.ssoWorkSimpli.STAGING;
    BASE_URL_SSO_DASHBOARD = baseUrl.ssoDashboard.STAGING;
    BASE_URL_SIGNSIMPI = baseUrl.signSimpli.STAGING;
    BASE_URL_PDFSIMPI = baseUrl.pdfSimpli.STAGING;
    BASE_URL_RESUMEBUILD = baseUrl.resumeBuild.STAGING;
    BASE_DASHBOARD_ORCHESTRATION = baseUrl.dashboardOrchestrationService.STAGING;
    BASE_URL_TRUSTPILOT = baseUrl.TrustPilotService.STAGING;
    BASE_URL_ABTEST = baseUrl.abtestService.STAGING;
    BASE_URL_LEGALSIMPLI = baseUrl.legalSimpli.STAGING;
    BASE_URL_DOCOPERATION_SERVICE = baseUrl.docOperationService.STAGING;
    BASE_URL_JOBMANAGER_SERVICE = baseUrl.jobManagerService.STAGING;
    BASE_URL_SIGNSIMPLI_ORCH_SERVICE = baseUrl.signSimpliOrchServcie.STAGING;
    BASE_URL_DOC_EDITOR_SERVICE = baseUrl.DocEditorService.STAGING;
    BASE_URL_DOCPROFILE_API = baseUrl.docProfileService.STAGING;
    BASE_URL_PDFSIMPLI_ENDPOINT = baseUrl.pdfsimpliEndPoint.STAGING;
    BASE_URL_SIGNSIMPLI_ENDPOINT = baseUrl.signsimpliEndPoint.STAGING;
    BASE_URL_WORKSIMPLI = baseUrl.worksimpliEndPoint.STAGING;
    break;
  case environment.PRODUCTION:
    BASE_URL_USER_SERVICE = baseUrl.userService.PRODUCTION;
    BASE_URL_DOCBUILDER_SERVICE = baseUrl.docBuilderService.PRODUCTION;
    BASE_URL_DOCPARSER_SERVICE = baseUrl.docParserService.PRODUCTION;
    BASE_URL_EVENT_SERVICE = baseUrl.eventService.PRODUCTION;
    BASE_URL_AUTH_SERVICE = baseUrl.authService.PRODUCTION;
    BASE_URL_META_CONTENT_SERVICE = baseUrl.metaContentService.PRODUCTION;
    BASE_URL_PAYMENT_SERVICE = baseUrl.paymentService.PRODUCTION;
    BASE_URL_ORDER_SERVICE = baseUrl.orderService.PRODUCTION;
    VISITOR_SERVICE_URL = baseUrlsVistorJs;
    BASE_URL_PAYMENT_ORCHESTRATION_SERVICE = baseUrl.orchestrationService.PRODUCTION;
    BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI = baseUrl.ssoPdfSimpli.PRODUCTION;
    BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI = baseUrl.ssoSignSimpli.PRODUCTION;
    BASE_URL_SSO_PARTNER_LOGIN_WORKSIMPLI = baseUrl.ssoWorkSimpli.PRODUCTION;
    BASE_URL_SSO_DASHBOARD = baseUrl.ssoDashboard.PRODUCTION;
    BASE_URL_SIGNSIMPI = baseUrl.signSimpli.PRODUCTION;
    BASE_URL_PDFSIMPI = baseUrl.pdfSimpli.PRODUCTION;
    BASE_URL_RESUMEBUILD = baseUrl.resumeBuild.PRODUCTION;
    BASE_DASHBOARD_ORCHESTRATION = baseUrl.dashboardOrchestrationService.PRODUCTION;
    BASE_URL_TRUSTPILOT = baseUrl.TrustPilotService.PRODUCTION;
    BASE_URL_ABTEST = baseUrl.abtestService.PRODUCTION;
    BASE_URL_LEGALSIMPLI = baseUrl.legalSimpli.PRODUCTION;
    BASE_URL_DOCOPERATION_SERVICE = baseUrl.docOperationService.PRODUCTION;
    BASE_URL_JOBMANAGER_SERVICE = baseUrl.jobManagerService.PRODUCTION;
    BASE_URL_SIGNSIMPLI_ORCH_SERVICE = baseUrl.signSimpliOrchServcie.PRODUCTION;
    BASE_URL_DOC_EDITOR_SERVICE = baseUrl.DocEditorService.PRODUCTION;
    BASE_URL_DOCPROFILE_API = baseUrl.docProfileService.PRODUCTION;
    BASE_URL_PDFSIMPLI_ENDPOINT = baseUrl.pdfsimpliEndPoint.PRODUCTION;
    BASE_URL_SIGNSIMPLI_ENDPOINT = baseUrl.signsimpliEndPoint.PRODUCTION;
    BASE_URL_WORKSIMPLI = baseUrl.worksimpliEndPoint.PRODUCTION;
    break;
  default:
    BASE_URL_USER_SERVICE = baseUrl.userService.QA;
    BASE_URL_DOCBUILDER_SERVICE = baseUrl.docBuilderService.QA;
    BASE_URL_DOCPARSER_SERVICE = baseUrl.docParserService.QA;
    BASE_URL_EVENT_SERVICE = baseUrl.eventService.QA;
    BASE_URL_AUTH_SERVICE = baseUrl.authService.QA;
    BASE_URL_META_CONTENT_SERVICE = baseUrl.metaContentService.QA;
    BASE_URL_PAYMENT_SERVICE = baseUrl.paymentService.QA;
    BASE_URL_ORDER_SERVICE = baseUrl.orderService.QA;
    VISITOR_SERVICE_URL = baseUrlsVistorJs;
    BASE_URL_PAYMENT_ORCHESTRATION_SERVICE = baseUrl.orchestrationService.DEVELOPMENT;
    BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI = baseUrl.ssoPdfSimpli.QA;
    BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI = baseUrl.ssoSignSimpli.QA;
    BASE_URL_SSO_PARTNER_LOGIN_WORKSIMPLI = baseUrl.ssoWorkSimpli.QA;
    BASE_URL_SSO_DASHBOARD = baseUrl.ssoDashboard.QA;
    BASE_URL_SIGNSIMPI = baseUrl.signSimpli.QA;
    BASE_URL_PDFSIMPI = baseUrl.pdfSimpli.QA;
    BASE_URL_RESUMEBUILD = baseUrl.resumeBuild.QA;
    BASE_URL_ABTEST = baseUrl.abtestService.QA;
    BASE_URL_LEGALSIMPLI = baseUrl.legalSimpli.QA;
    BASE_URL_DOCOPERATION_SERVICE = baseUrl.docOperationService.QA;
    BASE_URL_JOBMANAGER_SERVICE = baseUrl.jobManagerService.QA;
    BASE_URL_SIGNSIMPLI_ORCH_SERVICE = baseUrl.signSimpliOrchServcie.QA;
    BASE_URL_DOC_EDITOR_SERVICE = baseUrl.DocEditorService.QA;
    BASE_URL_DOCPROFILE_API = baseUrl.docProfileService.QA;
    BASE_URL_PDFSIMPLI_ENDPOINT = baseUrl.pdfsimpliEndPoint.QA;
    BASE_URL_SIGNSIMPLI_ENDPOINT = baseUrl.signsimpliEndPoint.QA;
    BASE_URL_WORKSIMPLI = baseUrl.worksimpliEndPoint.QA;
    break;
}

export const endPoints = {
  userService: {
    API_V1: "/api/v1",
    API_V2: "/api/v2",
    CREATE_USER: "/api/v2/user",
    CREATE_EXTERNAL_USER: "/api/v2/user/social",
    UPDATE_PWD: "/api/v2/user/change-password",
    RESET_PWD: "/api/v2/user/reset-password",
    GET_USER_PROFILE: "/api/v2/userprofile/:userGuid",
    SIGNIN_AS_ADMIN: "/api/v2/user/admin",
    GET_USER_BY_EMAIL: "/api/v2/user/search?email=:email&tenantGroupId=:tenantGroupId",
    GET_USER_BY_USERNAME: "/api/v2/user/search?username=:username&tenantGroupId=:tenantGroupId",
    FORGOT_PWD: "/api/v2/user/forgot-password",
    GET_USER_BY_GUID: "/api/v2/user/search?userguid=:guid&tenantGroupId=:tenantGroupId",
    GET_USER_OBJECT: "/api/v2/user/abridged",
    LOGIN_ATTEMPT: "/api/v2/user/login-attempt",
    RECAPTCHA_SCORE: "/api/v2/user/captcha-score?greToken=:greToken&portal=:portal",
    VALIDATE_LGCT_EXPIRY: "/api/v2/user/validate-lgct-token?token=:token",
    SAVE_USER_ADDRESS: "/api/v2/user/address",
    IP_2_CONNECT: "/api/v2/user/ip2connect?ipaddress=:ipaddress",
    GET_USERPROFILE: "/api/v2/userprofile/:userGuid",
    UPDATE_HAS_VIEW: "/api/v2/userprofile/:userGuid/hasview",
    VALIDATE_GUEST_TOKEN: "/api/v2/user/guest/validate-token",
    DOCUMENT_UPDATE: "/api/v2/userprofile/:userGuid/document",
    USER: "/api/v1/user/:userGuid",
  },
  docBuilderService: {
    API_V1: "/api/v1",
    CREATE_DOCUMENT: "doc",
    GET_DOCUMENT: "doc/:docId",
    DUPLICATE_DOCUMENT: "doc/:docId/duplicate",
    DELETE_DOCUMENT: "doc/:docId",
    UPDATE_DOC_STYLE: "doc/:docId/docstyle",
    DELETE_DOC_STYLE: "doc/:docId/paragraph/:paraId",
    UPDATE_PARAGRAPH_ORDERING: "doc/:docId/para-reorder",
    CHOOSE_TEMPLATE: "doc/:docId/choose-template",
    UPDATE_PARAGRAPH: "doc/:docId/paragraph/:paraId",
    RENAME_PARAGRAPH: "doc/:docId/paragraph/:paraId/rename",
    // DOCUMENT_DOWNLOAD:
    //   "doc/:docId/download?downloadDocType=:downloadDocType&docConversionMethod=:docConversionMethod",
    DOCUMENT_DOWNLOAD:
      "doc/:docId/download?downloadDocType=:downloadDocType&docConversionMethod=:docConversionMethod&version=:version&userId=:userId&regenerateDoc=:regenerateDoc",
    //CONVERSION_STATUS: "doc/:conversionId/download-status",
    CONVERSION_STATUS: "doc/:docId/download-statusv2/:conversionId",
    RENAME_DOCUMENT: "doc/:docId/doc-rename",
    GENERATE_PDF_PATH: "doc/:docId/genereate-pdf-path?userId=:userId",
    DOC_PARSE: "doc",
    UPLOAD_IMAGE: "doc/:docId/image",
    GET_ALLDOCUMENT_OF_USER: "doc/user/:userGuid",
    GET_ABRIDGED_DATA: "doc/abridged?userGuid=:userGuid&typeofdoc=:typeofdoc",
    GET_USER_DOCUMENTS_ATTRIBUTES: "doc/attributes?userGuid=:userGuid&typeofdoc=:typeofdoc",
    UPDATE_USER_DOC_MAPPING: "doc/:docId/user",
  },
  eventService: {
    API_V1: "/api/v1",
    CREATE_EVENT: "/api/v1/event",
  },
  authService: {
    API_V1: "/api/v1",
    ADMIN_AS_USER: "v2/auth/admin",
    USER_AUTH: "v1/auth/user/generate-token-userguid",
    LOGIN_USER_AUTH: "v1/auth/user/generate-token",
    UNAUTH_USER: "v1/auth/service/generate-token",
    EXTERNAL_USER_AUTH: "v2/auth/external/token",
  },
  metaContentService: {
    API_V1: "/api/v1",
    GET_INDUSTRY: "docmetacontent/industry",
    WRITING_CONTENT: "docmetacontent/MetaContent",
    WRITING_CONTENT_BY_INDUSTRY: "docmetacontent/MetaContentByIndustry",
  },
  paymentService: {
    API_V1: "/api/v1",
    GET_PLANS: "payment-process/plans",
    PAYMENT_PROCESS: "payment-process",
    GET_SKU_DETAILS: "payment-process/sku",
    BAD_BINS: "payment-process/badbin",
    PAYMENT_INTENT: "payment-process/payment-intent",
    GET_GUSETUSER_PRICING:
      "payment-process/calculate/pricing?skuguid=:skuguid&currency=:currency&skucategory=:skucategory&users=:users",
    TAX_MATRIX: "payment-process/taxmatrix?statecode=:stateCode&zipcode=:zipCode&amount=:planAmount",
    PAYMENT_ERROR_ISVALID: "payment-process/payment-error/isvalid?errorid=:errorid",
    GET_CAPTURE_CONTEXT: "payment-process/capturecontext",
  },
  orderService: {
    API_V1: "/api/v1",
    GET_USER_ORDERS: "Order/GetUserOrders",
  },
  orchestrationService: {
    API_V1: "/api/v1",
    CHECKOUT: "checkout",
    BILLING_INFO: ":userGuid/billing/:localeVal",
    CANCEL_USER: "user/:userGuid/cancel",
    RESTART_SUB: "reactivate/user/:userGuid/order",
    SET_CONFIRMATION: "user/:userGuid/confirmation",
    GET_USER_PLANS: "plans/:userGuid",
    CHECKOUT_3DS: "checkout/3ds",
    GATEWAY_ABTEST: "gateway?cardtoken=:cardtoken&currency=:currency&portal=:portal",
    BAD_BINS: "gateway?cardtoken=:token&currency=:currency&portal=:portal&CountryCd=:CountryCd",
    DYNAMIC_PHONE_NUMBER: "dynamic-phonenumber?currencycd=:currencycd&portalcd=:portalcd",
    ADD_PAYMENT_ERROR: "payment-error",
    GET_PAYMENT_ERROR: "payment-error?userGuid=:userguid",
  },
  ssoLogin: {
    partnerLogin: "partner-login?legacyTicket=:legacyTicketCookie",
    partnerLogOut: "partner-logout",
  },
  dashboardOrchestrationService: {
    BILLING_INFO: "/api/v1/dashboard/billing/account/:userGuid/:locale",
    UPLOAD_DOCUMENT: "/api/v1/dashboard/upload-documents",
    GET_ALL_DOCUMENTS: "/api/v1/dashboard/doc/user/:userGuid",
    CONVERT_DOC: "/api/v1/dashboard/convert-document",
    COMPLETE_DOC: "/api/v2/dashboard/complete-document?jobId=:jobId&docId=:docId&itemType=:itemType&fileType=:fileType",
    SAS_TOKEN: "/api/v2/dashboard/generate-sas-token?expiryHours=:expiryHours",
    TRANSCRIPTION_DOWNLOAD: "/api/v1/transcription/document-info",
    SHARE_OR_EMAIL: "/api/v1/dashboard/email-documents",
  },
  abtestService: {
    USER_CONDUCT: "/api/v1/abtest/user/conduct",
    VISITOR_CONDUCT: "/api/v1/abtest/visitor/conduct",
    AB_TESTDATA: "/api/v1/abtestdata/:abTestId?userGuid=:userGuid",
    SWITCH_VISITOR_USER: "/api/v1/abtest/switch-visitor-user",
  },
  docOperationService: {
    DOC_OPERATION: "doc-operation",
  },
  jobManagerService: {
    JOB_STATUS: "jobstatus/:operationId",
  },
  signSimpliOrchServcie: {
    ENVELOP_DOCUMENT_BY_DOCID: "signsimpli/envelop/:docid/envelop-document-by-docid",
    GET_ENVELOP_BY_ENVELOPID: "signsimpli/envelop/:envelopid",
    UPDATE_ENVELOP_BY_ENVELOPDOCID: "signsimpli/envelop-document/:envelopedocid",
    UPDATE_ENVELOP_DOCUMENT: "signsimpli/update-envelope-document",
    UPDATE_ENVELOP: "signsimpli/update-envelope",
    GET_ENVELOP_DOCUMENT: "signsimpli/envelop/:envelopId/envelope-document",
  },
  docEditorService: {
    EDITOR_INFO: "api/v1/operation/editor-info?id=:id",
    PROCESS_ANNOTATION: "api/v1/annotations/process-annotation",
    REPLACE_SIGNATURE: "api/v1/operation/replace-signature",
    ADD_WIZARD: "api/v1/wizard",
  },
  docProfileService: {
    BLOB_DOWNLOAD:
      "api/v1/docprofile/generate-uri-download?blobContainer=:blobContainer&fileName=:fileName&newFileName=:newFileName",
    CREATE_DOCPROFILE: "api/v1/docprofile?userid=:userid&isnewsetup=:isnewsetup",
    GET_COMPLETE_DOCPROFILE: "api/v1/docprofile?userid=:userid",
    GET_DOCPROFILE: "api/v1/docprofile/:userid/doc/:docid",
    UPDATE_DOCPROFILE: "api/v1/docprofile/user/:userid/doc",
  },
  pdfsimpliController: {
    ADD_WIZARD: "document/add-wizard",
  },
  signsimpliController: {
    ADD_WIZARD: "/document/add-wizard",
  },
};
const getBaseUrl = (baseUrl) => {
  return (endPoint) => {
    return `${baseUrl}${endPoint}`;
  };
};
const getBaseUrlV2 = (baseUrl) => {
  return `${baseUrl}`;
};

export const getUserServiceEndPoint = getBaseUrl(BASE_URL_USER_SERVICE);
export const getDocBuilderServicendPoint = getBaseUrl(BASE_URL_DOCBUILDER_SERVICE);
export const getDocParserServicendPoint = getBaseUrl(BASE_URL_DOCPARSER_SERVICE);

export const getEventServiceEndPoint = getBaseUrl(BASE_URL_EVENT_SERVICE);
export const getAuthServiceEndPoint = getBaseUrl(BASE_URL_AUTH_SERVICE);
export const getMetaContentServiceEndPoint = getBaseUrl(BASE_URL_META_CONTENT_SERVICE);

export const getVisitorServiceUrl = getBaseUrl(VISITOR_SERVICE_URL);
export const getPaymentServiceEndPoint = getBaseUrl(BASE_URL_PAYMENT_SERVICE);
export const ERROR_CODES = {
  UNAUTHORISED: 401,
};
export const getOrderServiceEndPoint = getBaseUrl(BASE_URL_ORDER_SERVICE);
export const getOrchestrationServiceEndPoint = getBaseUrl(BASE_URL_PAYMENT_ORCHESTRATION_SERVICE);
export const getSsoPdfsimpliEndPoint = getBaseUrl(BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI);
export const getSsoSignsimpliEndPoint = getBaseUrl(BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI);
export const getSsoWorkSimpliEndPoint = getBaseUrl(BASE_URL_SSO_PARTNER_LOGIN_WORKSIMPLI);
export const getSsoResumeBuildEndPoint = getBaseUrlV2(BASE_URL_SSO_DASHBOARD);

export const getDashboardOrchestrationServiceEndPoint = getBaseUrl(BASE_DASHBOARD_ORCHESTRATION);

export const getSignSimpliBaseURL = getBaseUrlV2(BASE_URL_SIGNSIMPI);
export const getPdfSimpliBaseURL = getBaseUrlV2(BASE_URL_PDFSIMPI);
export const getResumeBuildBaseURL = getBaseUrlV2(BASE_URL_RESUMEBUILD);
export const getWorksimpliEndPoint = getBaseUrlV2(BASE_URL_WORKSIMPLI);

export const getTrustPilotServiceEndPoint = getBaseUrlV2(BASE_URL_TRUSTPILOT);
export const getABTestEndPoint = getBaseUrl(BASE_URL_ABTEST);
export const getLegalSimpliBaseURL = getBaseUrlV2(BASE_URL_LEGALSIMPLI);
export const getDocOperationServiceEndPoint = getBaseUrl(BASE_URL_DOCOPERATION_SERVICE);
export const getJobManagerServiceEndPoint = getBaseUrl(BASE_URL_JOBMANAGER_SERVICE);
export const getSignSimpliOrchestrationServiceEndPoint = getBaseUrl(BASE_URL_SIGNSIMPLI_ORCH_SERVICE);
export const getDocEditorServiceEndPoint = getBaseUrl(BASE_URL_DOC_EDITOR_SERVICE);
export const getDocProfileEndPoint = getBaseUrl(BASE_URL_DOCPROFILE_API);
export const getPdfsimpliEndPoint = getBaseUrl(BASE_URL_PDFSIMPLI_ENDPOINT);
export const getSignsimpliEndPoint = getBaseUrl(BASE_URL_SIGNSIMPLI_ENDPOINT);
